export default __webpack_public_path__ + "static/media/blue.edc0e811.ogg";